unit View.Nfe.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, UUtils;

type
  TFViewNfeEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnfe_es: TLabel;
    ednfe_es: TDBEdit;
    lbnfe_complementar: TLabel;
    lbchave_acesso: TLabel;
    edchave_acesso: TDBEdit;
    lbnfe_transmissao: TLabel;
    ednfe_transmissao: TDBEdit;
    lbvalor_total: TLabel;
    edvalor_total: TDBEdit;
    lbnfe_cancelada: TLabel;
    lbcancelamento_justificativa: TLabel;
    edcancelamento_justificativa: TDBEdit;
    lbcancelamento_data: TLabel;
    edcancelamento_data: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientNfeGet: TXDataWebClient;
    NfeDataset: TXDataWebDataSet;
    NfeDatasetid: TIntegerField;
    NfeDatasetaliado_id: TIntegerField;
    NfeDatasetdata_base_id: TIntegerField;
    NfeDatasetnfe_lote_id: TIntegerField;
    NfeDatasetnfe_es: TIntegerField;
    NfeDatasetnfe_complementar: TBooleanField;
    NfeDatasetchave_acesso: TStringField;
    NfeDatasetnfe_transmissao: TDateTimeField;
    NfeDatasetvalor_total: TFloatField;
    NfeDatasetnfe_cancelada: TBooleanField;
    NfeDatasetcancelamento_justificativa: TStringField;
    NfeDatasetcancelamento_data: TDateTimeField;
    NfeDatasetxml_s3: TStringField;
    NfeDatasetcodigo_interno: TIntegerField;
    NfeDatasetexcluido: TBooleanField;
    NfeDatasetinclusao: TDateTimeField;
    NfeDatasetalteracao: TDateTimeField;
    NfeDatasetexclusao: TDateTimeField;
    cbxexcluido: TDBCheckBox;
    cbxnfe_cancelada: TDBCheckBox;
    cbxnfe_complementar: TDBCheckBox;
    btnCopiarChaveAcesso: TButton;
    pnlDadosNfe: TPanel;
    pnlDadosNfeLote: TPanel;
    lbid_lote: TLabel;
    edid_lote: TDBEdit;
    lbemissao: TLabel;
    edemissao: TDBEdit;
    lbcodigo: TLabel;
    edcodigo: TDBEdit;
    lbquantidade_nfe: TLabel;
    edquantidade_nfe: TDBEdit;
    lbcodigo_interno_lote: TLabel;
    edcodigo_interno_lote: TDBEdit;
    lbexcluido_lote: TLabel;
    lbinclusao_lote: TLabel;
    edinclusao_lote: TDBEdit;
    lbalteracao_lote: TLabel;
    edalteracao_lote: TDBEdit;
    lbexclusao_lote: TLabel;
    edexclusao_lote: TDBEdit;
    cbxexcluido_lote: TDBCheckBox;
    NfeDatasetnfe_loteid: TIntegerField;
    NfeDatasetnfe_loteemissao: TDateTimeField;
    NfeDatasetnfe_lotecodigo: TStringField;
    NfeDatasetnfe_lotequantidade_nfe: TIntegerField;
    NfeDatasetnfe_lotecodigo_interno: TIntegerField;
    NfeDatasetnfe_loteexcluido: TBooleanField;
    NfeDatasetnfe_loteinclusao: TDateTimeField;
    NfeDatasetnfe_lotealteracao: TDateTimeField;
    NfeDatasetnfe_loteexclusao: TDateTimeField;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientNfeGetLoad(Response: TXDataClientResponse);
    procedure NfeDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure NfeDatasetnfe_esGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure btnCopiarChaveAcessoClick(Sender: TObject);
    procedure NfeDatasetAfterOpen(DataSet: TDataSet);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewNfeEdit: TFViewNfeEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewNfeEdit }

procedure TFViewNfeEdit.btnCopiarChaveAcessoClick(Sender: TObject);
begin
  THelperServer.CopiarTextoNotificacao('Chave de acesso copiada com sucesso!', 'Cópia de chave de acesso',
    edchave_acesso.Text);
end;

class function TFViewNfeEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewNfeEdit.InsertEntity;
begin
  NfeDataset.Close;
  NfeDataset.SetJsonData('{}');
  NfeDataset.Open;
  NfeDataset.Insert;
end;

class function TFViewNfeEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNfeEdit(AForm).FInserting := AInserting;
    TFViewNfeEdit(AForm).FId := AId;
    TFViewNfeEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewNfeEdit(AForm).InsertEntity
    else
      TFViewNfeEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewNfeEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewNfeEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    NfeDataset.Connection.Model.DefaultSchema.FindEntityType(
      NfeDataset.EntitySetName
    )
  );
  XDataClientNfeGet.Get(NfeDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewNfeEdit.XDataClientNfeGetLoad(Response: TXDataClientResponse);
begin
  NfeDataset.Close;
  NfeDataset.SetJsonData(Response.Result);
  NfeDataset.Open;
  
  NfeDataset.Edit;

  if NfeDataset.FieldByName('nfe_lote_id').AsString.IsEmpty then
  begin
    TUtils.RemoverElementoPorId('line-lote-tab');
    TUtils.RemoverElementoPorId('line-lote');
  end;
end;

procedure TFViewNfeEdit.NfeDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewNfeEdit.NfeDatasetAfterOpen(DataSet: TDataSet);
begin
  if edchave_acesso.Text = '' then
    btnCopiarChaveAcesso.Enabled := False;
end;

procedure TFViewNfeEdit.NfeDatasetnfe_esGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  if not Sender.AsString.IsEmpty then
  begin
    if Sender.AsInteger = 0 then
      Text := 'ENTRADA'
    else
      Text := 'SAÍDA';
  end;
end;

procedure TFViewNfeEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewNfeEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.nfe.form.lbid');
  lbnfe_es := TLabel.Create('view.nfe.form.lbnfe_es');
  lbnfe_complementar := TLabel.Create('view.nfe.form.lbnfe_complementar');
  lbchave_acesso := TLabel.Create('view.nfe.form.lbchave_acesso');
  lbnfe_transmissao := TLabel.Create('view.nfe.form.lbnfe_transmissao');
  lbvalor_total := TLabel.Create('view.nfe.form.lbvalor_total');
  lbnfe_cancelada := TLabel.Create('view.nfe.form.lbnfe_cancelada');
  lbcancelamento_justificativa := TLabel.Create('view.nfe.form.lbcancelamento_justificativa');
  lbcancelamento_data := TLabel.Create('view.nfe.form.lbcancelamento_data');
  lbcodigo_interno := TLabel.Create('view.nfe.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.nfe.form.lbexcluido');
  lbinclusao := TLabel.Create('view.nfe.form.lbinclusao');
  lbalteracao := TLabel.Create('view.nfe.form.lbalteracao');
  lbexclusao := TLabel.Create('view.nfe.form.lbexclusao');
  lbid_lote := TLabel.Create('view.nfe_lote.form.lbid');
  lbemissao := TLabel.Create('view.nfe_lote.form.lbemissao');
  lbcodigo := TLabel.Create('view.nfe_lote.form.lbcodigo');
  lbquantidade_nfe := TLabel.Create('view.nfe_lote.form.lbquantidade_nfe');
  lbcodigo_interno_lote := TLabel.Create('view.nfe_lote.form.lbcodigo_interno');
  lbexcluido_lote := TLabel.Create('view.nfe_lote.form.lbexcluido');
  lbinclusao_lote := TLabel.Create('view.nfe_lote.form.lbinclusao');
  lbalteracao_lote := TLabel.Create('view.nfe_lote.form.lbalteracao');
  lbexclusao_lote := TLabel.Create('view.nfe_lote.form.lbexclusao');
  btCancel := TButton.Create('view.nfe.form.btBack');
  edid := TDBEdit.Create('view.nfe.form.edid');
  ednfe_es := TDBEdit.Create('view.nfe.form.ednfe_es');
  edchave_acesso := TDBEdit.Create('view.nfe.form.edchave_acesso');
  ednfe_transmissao := TDBEdit.Create('view.nfe.form.ednfe_transmissao');
  edvalor_total := TDBEdit.Create('view.nfe.form.edvalor_total');
  edcancelamento_justificativa := TDBEdit.Create('view.nfe.form.edcancelamento_justificativa');
  edcancelamento_data := TDBEdit.Create('view.nfe.form.edcancelamento_data');
  edcodigo_interno := TDBEdit.Create('view.nfe.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.nfe.form.edinclusao');
  edalteracao := TDBEdit.Create('view.nfe.form.edalteracao');
  edexclusao := TDBEdit.Create('view.nfe.form.edexclusao');
  cbxexcluido := TDBCheckBox.Create('view.nfe.form.cbxexcluido');
  cbxnfe_cancelada := TDBCheckBox.Create('view.nfe.form.cbxnfe_cancelada');
  cbxnfe_complementar := TDBCheckBox.Create('view.nfe.form.cbxnfe_complementar');
  btnCopiarChaveAcesso := TButton.Create('btnCopiarChaveAcesso');
  pnlDadosNfe := TPanel.Create(Self);
  pnlDadosNfeLote := TPanel.Create(Self);
  edid_lote := TDBEdit.Create('view.nfe_lote.form.edid');
  edemissao := TDBEdit.Create('view.nfe_lote.form.edemissao');
  edcodigo := TDBEdit.Create('view.nfe_lote.form.edcodigo');
  edquantidade_nfe := TDBEdit.Create('view.nfe_lote.form.edquantidade_nfe');
  edcodigo_interno_lote := TDBEdit.Create('view.nfe_lote.form.edcodigo_interno');
  edinclusao_lote := TDBEdit.Create('view.nfe_lote.form.edinclusao');
  edalteracao_lote := TDBEdit.Create('view.nfe_lote.form.edalteracao');
  edexclusao_lote := TDBEdit.Create('view.nfe_lote.form.edexclusao');
  cbxexcluido_lote := TDBCheckBox.Create('view.nfe_lote.form.cbxexcluido');
  DataSource := TDataSource.Create(Self);
  NfeDataset := TXDataWebDataSet.Create(Self);
  NfeDatasetid := TIntegerField.Create(Self);
  NfeDatasetaliado_id := TIntegerField.Create(Self);
  NfeDatasetdata_base_id := TIntegerField.Create(Self);
  NfeDatasetnfe_lote_id := TIntegerField.Create(Self);
  NfeDatasetnfe_es := TIntegerField.Create(Self);
  NfeDatasetnfe_complementar := TBooleanField.Create(Self);
  NfeDatasetchave_acesso := TStringField.Create(Self);
  NfeDatasetnfe_transmissao := TDateTimeField.Create(Self);
  NfeDatasetvalor_total := TFloatField.Create(Self);
  NfeDatasetnfe_cancelada := TBooleanField.Create(Self);
  NfeDatasetcancelamento_justificativa := TStringField.Create(Self);
  NfeDatasetcancelamento_data := TDateTimeField.Create(Self);
  NfeDatasetxml_s3 := TStringField.Create(Self);
  NfeDatasetcodigo_interno := TIntegerField.Create(Self);
  NfeDatasetexcluido := TBooleanField.Create(Self);
  NfeDatasetinclusao := TDateTimeField.Create(Self);
  NfeDatasetalteracao := TDateTimeField.Create(Self);
  NfeDatasetexclusao := TDateTimeField.Create(Self);
  NfeDatasetnfe_loteid := TIntegerField.Create(Self);
  NfeDatasetnfe_loteemissao := TDateTimeField.Create(Self);
  NfeDatasetnfe_lotecodigo := TStringField.Create(Self);
  NfeDatasetnfe_lotequantidade_nfe := TIntegerField.Create(Self);
  NfeDatasetnfe_lotecodigo_interno := TIntegerField.Create(Self);
  NfeDatasetnfe_loteexcluido := TBooleanField.Create(Self);
  NfeDatasetnfe_loteinclusao := TDateTimeField.Create(Self);
  NfeDatasetnfe_lotealteracao := TDateTimeField.Create(Self);
  NfeDatasetnfe_loteexclusao := TDateTimeField.Create(Self);
  XDataClientNfeGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnfe_es.BeforeLoadDFMValues;
  lbnfe_complementar.BeforeLoadDFMValues;
  lbchave_acesso.BeforeLoadDFMValues;
  lbnfe_transmissao.BeforeLoadDFMValues;
  lbvalor_total.BeforeLoadDFMValues;
  lbnfe_cancelada.BeforeLoadDFMValues;
  lbcancelamento_justificativa.BeforeLoadDFMValues;
  lbcancelamento_data.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbid_lote.BeforeLoadDFMValues;
  lbemissao.BeforeLoadDFMValues;
  lbcodigo.BeforeLoadDFMValues;
  lbquantidade_nfe.BeforeLoadDFMValues;
  lbcodigo_interno_lote.BeforeLoadDFMValues;
  lbexcluido_lote.BeforeLoadDFMValues;
  lbinclusao_lote.BeforeLoadDFMValues;
  lbalteracao_lote.BeforeLoadDFMValues;
  lbexclusao_lote.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednfe_es.BeforeLoadDFMValues;
  edchave_acesso.BeforeLoadDFMValues;
  ednfe_transmissao.BeforeLoadDFMValues;
  edvalor_total.BeforeLoadDFMValues;
  edcancelamento_justificativa.BeforeLoadDFMValues;
  edcancelamento_data.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  cbxnfe_cancelada.BeforeLoadDFMValues;
  cbxnfe_complementar.BeforeLoadDFMValues;
  btnCopiarChaveAcesso.BeforeLoadDFMValues;
  pnlDadosNfe.BeforeLoadDFMValues;
  pnlDadosNfeLote.BeforeLoadDFMValues;
  edid_lote.BeforeLoadDFMValues;
  edemissao.BeforeLoadDFMValues;
  edcodigo.BeforeLoadDFMValues;
  edquantidade_nfe.BeforeLoadDFMValues;
  edcodigo_interno_lote.BeforeLoadDFMValues;
  edinclusao_lote.BeforeLoadDFMValues;
  edalteracao_lote.BeforeLoadDFMValues;
  edexclusao_lote.BeforeLoadDFMValues;
  cbxexcluido_lote.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  NfeDataset.BeforeLoadDFMValues;
  NfeDatasetid.BeforeLoadDFMValues;
  NfeDatasetaliado_id.BeforeLoadDFMValues;
  NfeDatasetdata_base_id.BeforeLoadDFMValues;
  NfeDatasetnfe_lote_id.BeforeLoadDFMValues;
  NfeDatasetnfe_es.BeforeLoadDFMValues;
  NfeDatasetnfe_complementar.BeforeLoadDFMValues;
  NfeDatasetchave_acesso.BeforeLoadDFMValues;
  NfeDatasetnfe_transmissao.BeforeLoadDFMValues;
  NfeDatasetvalor_total.BeforeLoadDFMValues;
  NfeDatasetnfe_cancelada.BeforeLoadDFMValues;
  NfeDatasetcancelamento_justificativa.BeforeLoadDFMValues;
  NfeDatasetcancelamento_data.BeforeLoadDFMValues;
  NfeDatasetxml_s3.BeforeLoadDFMValues;
  NfeDatasetcodigo_interno.BeforeLoadDFMValues;
  NfeDatasetexcluido.BeforeLoadDFMValues;
  NfeDatasetinclusao.BeforeLoadDFMValues;
  NfeDatasetalteracao.BeforeLoadDFMValues;
  NfeDatasetexclusao.BeforeLoadDFMValues;
  NfeDatasetnfe_loteid.BeforeLoadDFMValues;
  NfeDatasetnfe_loteemissao.BeforeLoadDFMValues;
  NfeDatasetnfe_lotecodigo.BeforeLoadDFMValues;
  NfeDatasetnfe_lotequantidade_nfe.BeforeLoadDFMValues;
  NfeDatasetnfe_lotecodigo_interno.BeforeLoadDFMValues;
  NfeDatasetnfe_loteexcluido.BeforeLoadDFMValues;
  NfeDatasetnfe_loteinclusao.BeforeLoadDFMValues;
  NfeDatasetnfe_lotealteracao.BeforeLoadDFMValues;
  NfeDatasetnfe_loteexclusao.BeforeLoadDFMValues;
  XDataClientNfeGet.BeforeLoadDFMValues;
  try
    Name := 'FViewNfeEdit';
    Width := 544;
    Height := 480;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 24;
    lbid.Width := 70;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Servidor:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnfe_es.SetParentComponent(Self);
    lbnfe_es.Name := 'lbnfe_es';
    lbnfe_es.Left := 8;
    lbnfe_es.Top := 51;
    lbnfe_es.Width := 24;
    lbnfe_es.Height := 13;
    lbnfe_es.Caption := 'Tipo:';
    lbnfe_es.HeightPercent := 100.000000000000000000;
    lbnfe_es.WidthPercent := 100.000000000000000000;
    lbnfe_complementar.SetParentComponent(Self);
    lbnfe_complementar.Name := 'lbnfe_complementar';
    lbnfe_complementar.Left := 8;
    lbnfe_complementar.Top := 78;
    lbnfe_complementar.Width := 96;
    lbnfe_complementar.Height := 13;
    lbnfe_complementar.Caption := 'NFe Complementar?';
    lbnfe_complementar.HeightPercent := 100.000000000000000000;
    lbnfe_complementar.WidthPercent := 100.000000000000000000;
    lbchave_acesso.SetParentComponent(Self);
    lbchave_acesso.Name := 'lbchave_acesso';
    lbchave_acesso.Left := 8;
    lbchave_acesso.Top := 105;
    lbchave_acesso.Width := 72;
    lbchave_acesso.Height := 13;
    lbchave_acesso.Caption := 'Chave Acesso:';
    lbchave_acesso.HeightPercent := 100.000000000000000000;
    lbchave_acesso.WidthPercent := 100.000000000000000000;
    lbnfe_transmissao.SetParentComponent(Self);
    lbnfe_transmissao.Name := 'lbnfe_transmissao';
    lbnfe_transmissao.Left := 8;
    lbnfe_transmissao.Top := 132;
    lbnfe_transmissao.Width := 63;
    lbnfe_transmissao.Height := 13;
    lbnfe_transmissao.Caption := 'Transmiss'#227'o:';
    lbnfe_transmissao.HeightPercent := 100.000000000000000000;
    lbnfe_transmissao.WidthPercent := 100.000000000000000000;
    lbvalor_total.SetParentComponent(Self);
    lbvalor_total.Name := 'lbvalor_total';
    lbvalor_total.Left := 8;
    lbvalor_total.Top := 159;
    lbvalor_total.Width := 55;
    lbvalor_total.Height := 13;
    lbvalor_total.Caption := 'Valor Total:';
    lbvalor_total.HeightPercent := 100.000000000000000000;
    lbvalor_total.WidthPercent := 100.000000000000000000;
    lbnfe_cancelada.SetParentComponent(Self);
    lbnfe_cancelada.Name := 'lbnfe_cancelada';
    lbnfe_cancelada.Left := 8;
    lbnfe_cancelada.Top := 186;
    lbnfe_cancelada.Width := 75;
    lbnfe_cancelada.Height := 13;
    lbnfe_cancelada.Caption := 'Nfe Cancelada?';
    lbnfe_cancelada.HeightPercent := 100.000000000000000000;
    lbnfe_cancelada.WidthPercent := 100.000000000000000000;
    lbcancelamento_justificativa.SetParentComponent(Self);
    lbcancelamento_justificativa.Name := 'lbcancelamento_justificativa';
    lbcancelamento_justificativa.Left := 272;
    lbcancelamento_justificativa.Top := 24;
    lbcancelamento_justificativa.Width := 132;
    lbcancelamento_justificativa.Height := 13;
    lbcancelamento_justificativa.Caption := 'Justificativa Cancelamento:';
    lbcancelamento_justificativa.HeightPercent := 100.000000000000000000;
    lbcancelamento_justificativa.WidthPercent := 100.000000000000000000;
    lbcancelamento_data.SetParentComponent(Self);
    lbcancelamento_data.Name := 'lbcancelamento_data';
    lbcancelamento_data.Left := 272;
    lbcancelamento_data.Top := 51;
    lbcancelamento_data.Width := 98;
    lbcancelamento_data.Height := 13;
    lbcancelamento_data.Caption := 'Data Cancelamento:';
    lbcancelamento_data.HeightPercent := 100.000000000000000000;
    lbcancelamento_data.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 272;
    lbcodigo_interno.Top := 78;
    lbcodigo_interno.Width := 87;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Retaguarda:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 272;
    lbexcluido.Top := 105;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 272;
    lbinclusao.Top := 132;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 272;
    lbalteracao.Top := 159;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 272;
    lbexclusao.Top := 186;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbid_lote.SetParentComponent(Self);
    lbid_lote.Name := 'lbid_lote';
    lbid_lote.Left := 16;
    lbid_lote.Top := 304;
    lbid_lote.Width := 70;
    lbid_lote.Height := 13;
    lbid_lote.Caption := 'C'#243'd. Servidor:';
    lbid_lote.HeightPercent := 100.000000000000000000;
    lbid_lote.WidthPercent := 100.000000000000000000;
    lbemissao.SetParentComponent(Self);
    lbemissao.Name := 'lbemissao';
    lbemissao.Left := 16;
    lbemissao.Top := 408;
    lbemissao.Width := 42;
    lbemissao.Height := 13;
    lbemissao.Caption := 'Emiss'#227'o:';
    lbemissao.HeightPercent := 100.000000000000000000;
    lbemissao.WidthPercent := 100.000000000000000000;
    lbcodigo.SetParentComponent(Self);
    lbcodigo.Name := 'lbcodigo';
    lbcodigo.Left := 16;
    lbcodigo.Top := 331;
    lbcodigo.Width := 37;
    lbcodigo.Height := 13;
    lbcodigo.Caption := 'C'#243'digo:';
    lbcodigo.HeightPercent := 100.000000000000000000;
    lbcodigo.WidthPercent := 100.000000000000000000;
    lbquantidade_nfe.SetParentComponent(Self);
    lbquantidade_nfe.Name := 'lbquantidade_nfe';
    lbquantidade_nfe.Left := 16;
    lbquantidade_nfe.Top := 356;
    lbquantidade_nfe.Width := 54;
    lbquantidade_nfe.Height := 13;
    lbquantidade_nfe.Caption := 'Qtde. NFe:';
    lbquantidade_nfe.HeightPercent := 100.000000000000000000;
    lbquantidade_nfe.WidthPercent := 100.000000000000000000;
    lbcodigo_interno_lote.SetParentComponent(Self);
    lbcodigo_interno_lote.Name := 'lbcodigo_interno_lote';
    lbcodigo_interno_lote.Left := 16;
    lbcodigo_interno_lote.Top := 383;
    lbcodigo_interno_lote.Width := 87;
    lbcodigo_interno_lote.Height := 13;
    lbcodigo_interno_lote.Caption := 'C'#243'd. Retaguarda:';
    lbcodigo_interno_lote.HeightPercent := 100.000000000000000000;
    lbcodigo_interno_lote.WidthPercent := 100.000000000000000000;
    lbexcluido_lote.SetParentComponent(Self);
    lbexcluido_lote.Name := 'lbexcluido_lote';
    lbexcluido_lote.Left := 267;
    lbexcluido_lote.Top := 304;
    lbexcluido_lote.Width := 44;
    lbexcluido_lote.Height := 13;
    lbexcluido_lote.Caption := 'Exclu'#237'do?';
    lbexcluido_lote.HeightPercent := 100.000000000000000000;
    lbexcluido_lote.WidthPercent := 100.000000000000000000;
    lbinclusao_lote.SetParentComponent(Self);
    lbinclusao_lote.Name := 'lbinclusao_lote';
    lbinclusao_lote.Left := 267;
    lbinclusao_lote.Top := 331;
    lbinclusao_lote.Width := 44;
    lbinclusao_lote.Height := 13;
    lbinclusao_lote.Caption := 'Inclus'#227'o:';
    lbinclusao_lote.HeightPercent := 100.000000000000000000;
    lbinclusao_lote.WidthPercent := 100.000000000000000000;
    lbalteracao_lote.SetParentComponent(Self);
    lbalteracao_lote.Name := 'lbalteracao_lote';
    lbalteracao_lote.Left := 267;
    lbalteracao_lote.Top := 358;
    lbalteracao_lote.Width := 50;
    lbalteracao_lote.Height := 13;
    lbalteracao_lote.Caption := 'Altera'#231#227'o:';
    lbalteracao_lote.HeightPercent := 100.000000000000000000;
    lbalteracao_lote.WidthPercent := 100.000000000000000000;
    lbexclusao_lote.SetParentComponent(Self);
    lbexclusao_lote.Name := 'lbexclusao_lote';
    lbexclusao_lote.Left := 267;
    lbexclusao_lote.Top := 385;
    lbexclusao_lote.Width := 46;
    lbexclusao_lote.Height := 13;
    lbexclusao_lote.Caption := 'Exclus'#227'o:';
    lbexclusao_lote.HeightPercent := 100.000000000000000000;
    lbexclusao_lote.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 373;
    btCancel.Top := 227;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 133;
    edid.Top := 21;
    edid.Width := 100;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednfe_es.SetParentComponent(Self);
    ednfe_es.Name := 'ednfe_es';
    ednfe_es.Left := 133;
    ednfe_es.Top := 48;
    ednfe_es.Width := 100;
    ednfe_es.Height := 21;
    ednfe_es.Enabled := False;
    ednfe_es.HeightPercent := 100.000000000000000000;
    ednfe_es.TabOrder := 10;
    ednfe_es.Text := 'ednfe_es';
    ednfe_es.WidthPercent := 100.000000000000000000;
    ednfe_es.DataField := 'nfe_es';
    ednfe_es.DataSource := DataSource;
    edchave_acesso.SetParentComponent(Self);
    edchave_acesso.Name := 'edchave_acesso';
    edchave_acesso.Left := 133;
    edchave_acesso.Top := 102;
    edchave_acesso.Width := 100;
    edchave_acesso.Height := 21;
    edchave_acesso.Enabled := False;
    edchave_acesso.HeightPercent := 100.000000000000000000;
    edchave_acesso.TabOrder := 12;
    edchave_acesso.Text := 'edchave_acesso';
    edchave_acesso.WidthPercent := 100.000000000000000000;
    edchave_acesso.DataField := 'chave_acesso';
    edchave_acesso.DataSource := DataSource;
    ednfe_transmissao.SetParentComponent(Self);
    ednfe_transmissao.Name := 'ednfe_transmissao';
    ednfe_transmissao.Left := 133;
    ednfe_transmissao.Top := 129;
    ednfe_transmissao.Width := 100;
    ednfe_transmissao.Height := 21;
    ednfe_transmissao.Enabled := False;
    ednfe_transmissao.HeightPercent := 100.000000000000000000;
    ednfe_transmissao.TabOrder := 13;
    ednfe_transmissao.Text := 'ednfe_transmissao';
    ednfe_transmissao.WidthPercent := 100.000000000000000000;
    ednfe_transmissao.DataField := 'nfe_transmissao';
    ednfe_transmissao.DataSource := DataSource;
    edvalor_total.SetParentComponent(Self);
    edvalor_total.Name := 'edvalor_total';
    edvalor_total.Left := 133;
    edvalor_total.Top := 156;
    edvalor_total.Width := 100;
    edvalor_total.Height := 21;
    edvalor_total.Enabled := False;
    edvalor_total.HeightPercent := 100.000000000000000000;
    edvalor_total.TabOrder := 14;
    edvalor_total.Text := 'edvalor_total';
    edvalor_total.WidthPercent := 100.000000000000000000;
    edvalor_total.DataField := 'valor_total';
    edvalor_total.DataSource := DataSource;
    edcancelamento_justificativa.SetParentComponent(Self);
    edcancelamento_justificativa.Name := 'edcancelamento_justificativa';
    edcancelamento_justificativa.Left := 437;
    edcancelamento_justificativa.Top := 21;
    edcancelamento_justificativa.Width := 100;
    edcancelamento_justificativa.Height := 21;
    edcancelamento_justificativa.Enabled := False;
    edcancelamento_justificativa.HeightPercent := 100.000000000000000000;
    edcancelamento_justificativa.TabOrder := 16;
    edcancelamento_justificativa.Text := 'edcancelamento_justificativa';
    edcancelamento_justificativa.WidthPercent := 100.000000000000000000;
    edcancelamento_justificativa.DataField := 'cancelamento_justificativa';
    edcancelamento_justificativa.DataSource := DataSource;
    edcancelamento_data.SetParentComponent(Self);
    edcancelamento_data.Name := 'edcancelamento_data';
    edcancelamento_data.Left := 437;
    edcancelamento_data.Top := 48;
    edcancelamento_data.Width := 100;
    edcancelamento_data.Height := 21;
    edcancelamento_data.Enabled := False;
    edcancelamento_data.HeightPercent := 100.000000000000000000;
    edcancelamento_data.TabOrder := 17;
    edcancelamento_data.Text := 'edcancelamento_data';
    edcancelamento_data.WidthPercent := 100.000000000000000000;
    edcancelamento_data.DataField := 'cancelamento_data';
    edcancelamento_data.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 437;
    edcodigo_interno.Top := 75;
    edcodigo_interno.Width := 100;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 19;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 437;
    edinclusao.Top := 129;
    edinclusao.Width := 100;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 21;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 437;
    edalteracao.Top := 156;
    edalteracao.Width := 100;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 22;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 437;
    edexclusao.Top := 183;
    edexclusao.Width := 100;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 23;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 437;
    cbxexcluido.Top := 102;
    cbxexcluido.Width := 100;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    cbxnfe_cancelada.SetParentComponent(Self);
    cbxnfe_cancelada.Name := 'cbxnfe_cancelada';
    cbxnfe_cancelada.Left := 133;
    cbxnfe_cancelada.Top := 183;
    cbxnfe_cancelada.Width := 100;
    cbxnfe_cancelada.Height := 22;
    cbxnfe_cancelada.Caption := 'cbxnfe_cancelada';
    cbxnfe_cancelada.ChildOrder := 33;
    cbxnfe_cancelada.Enabled := False;
    cbxnfe_cancelada.HeightPercent := 100.000000000000000000;
    cbxnfe_cancelada.WidthPercent := 100.000000000000000000;
    cbxnfe_cancelada.DataField := 'nfe_cancelada';
    cbxnfe_cancelada.DataSource := DataSource;
    cbxnfe_complementar.SetParentComponent(Self);
    cbxnfe_complementar.Name := 'cbxnfe_complementar';
    cbxnfe_complementar.Left := 133;
    cbxnfe_complementar.Top := 75;
    cbxnfe_complementar.Width := 100;
    cbxnfe_complementar.Height := 22;
    cbxnfe_complementar.Caption := 'cbxnfe_complementar';
    cbxnfe_complementar.ChildOrder := 33;
    cbxnfe_complementar.Enabled := False;
    cbxnfe_complementar.HeightPercent := 100.000000000000000000;
    cbxnfe_complementar.WidthPercent := 100.000000000000000000;
    cbxnfe_complementar.DataField := 'nfe_complementar';
    cbxnfe_complementar.DataSource := DataSource;
    btnCopiarChaveAcesso.SetParentComponent(Self);
    btnCopiarChaveAcesso.Name := 'btnCopiarChaveAcesso';
    btnCopiarChaveAcesso.Left := 234;
    btnCopiarChaveAcesso.Top := 102;
    btnCopiarChaveAcesso.Width := 30;
    btnCopiarChaveAcesso.Height := 21;
    btnCopiarChaveAcesso.ChildOrder := 22;
    btnCopiarChaveAcesso.HeightPercent := 100.000000000000000000;
    btnCopiarChaveAcesso.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopiarChaveAcesso, Self, 'OnClick', 'btnCopiarChaveAcessoClick');
    pnlDadosNfe.SetParentComponent(Self);
    pnlDadosNfe.Name := 'pnlDadosNfe';
    pnlDadosNfe.Left := 8;
    pnlDadosNfe.Top := 0;
    pnlDadosNfe.Width := 528;
    pnlDadosNfe.Height := 17;
    pnlDadosNfe.Caption := 'Espa'#231'o Dados NFe';
    pnlDadosNfe.ChildOrder := 23;
    pnlDadosNfe.Color := clInfoText;
    pnlDadosNfe.Font.Charset := DEFAULT_CHARSET;
    pnlDadosNfe.Font.Color := clWhite;
    pnlDadosNfe.Font.Height := -11;
    pnlDadosNfe.Font.Name := 'Tahoma';
    pnlDadosNfe.Font.Style := [fsBold];
    pnlDadosNfe.ParentFont := False;
    pnlDadosNfe.TabOrder := 16;
    pnlDadosNfe.Visible := False;
    pnlDadosNfeLote.SetParentComponent(Self);
    pnlDadosNfeLote.Name := 'pnlDadosNfeLote';
    pnlDadosNfeLote.Left := 8;
    pnlDadosNfeLote.Top := 275;
    pnlDadosNfeLote.Width := 528;
    pnlDadosNfeLote.Height := 17;
    pnlDadosNfeLote.Caption := 'Espa'#231'o Dados NFe Lote';
    pnlDadosNfeLote.ChildOrder := 23;
    pnlDadosNfeLote.Color := clInfoText;
    pnlDadosNfeLote.Font.Charset := DEFAULT_CHARSET;
    pnlDadosNfeLote.Font.Color := clWhite;
    pnlDadosNfeLote.Font.Height := -11;
    pnlDadosNfeLote.Font.Name := 'Tahoma';
    pnlDadosNfeLote.Font.Style := [fsBold];
    pnlDadosNfeLote.ParentFont := False;
    pnlDadosNfeLote.TabOrder := 17;
    pnlDadosNfeLote.Visible := False;
    edid_lote.SetParentComponent(Self);
    edid_lote.Name := 'edid_lote';
    edid_lote.Left := 133;
    edid_lote.Top := 301;
    edid_lote.Width := 100;
    edid_lote.Height := 21;
    edid_lote.ChildOrder := 33;
    edid_lote.Enabled := False;
    edid_lote.HeightPercent := 100.000000000000000000;
    edid_lote.TabOrder := 6;
    edid_lote.Text := 'edid';
    edid_lote.WidthPercent := 100.000000000000000000;
    edid_lote.DataField := 'nfe_lote.id';
    edid_lote.DataSource := DataSource;
    edemissao.SetParentComponent(Self);
    edemissao.Name := 'edemissao';
    edemissao.Left := 133;
    edemissao.Top := 405;
    edemissao.Width := 100;
    edemissao.Height := 21;
    edemissao.ChildOrder := 35;
    edemissao.Enabled := False;
    edemissao.HeightPercent := 100.000000000000000000;
    edemissao.TabOrder := 9;
    edemissao.Text := 'edemissao';
    edemissao.WidthPercent := 100.000000000000000000;
    edemissao.DataField := 'nfe_lote.emissao';
    edemissao.DataSource := DataSource;
    edcodigo.SetParentComponent(Self);
    edcodigo.Name := 'edcodigo';
    edcodigo.Left := 133;
    edcodigo.Top := 328;
    edcodigo.Width := 100;
    edcodigo.Height := 21;
    edcodigo.ChildOrder := 37;
    edcodigo.Enabled := False;
    edcodigo.HeightPercent := 100.000000000000000000;
    edcodigo.TabOrder := 10;
    edcodigo.Text := 'edcodigo';
    edcodigo.WidthPercent := 100.000000000000000000;
    edcodigo.DataField := 'nfe_lote.codigo';
    edcodigo.DataSource := DataSource;
    edquantidade_nfe.SetParentComponent(Self);
    edquantidade_nfe.Name := 'edquantidade_nfe';
    edquantidade_nfe.Left := 133;
    edquantidade_nfe.Top := 353;
    edquantidade_nfe.Width := 100;
    edquantidade_nfe.Height := 21;
    edquantidade_nfe.ChildOrder := 39;
    edquantidade_nfe.Enabled := False;
    edquantidade_nfe.HeightPercent := 100.000000000000000000;
    edquantidade_nfe.TabOrder := 11;
    edquantidade_nfe.Text := 'edquantidade_nfe';
    edquantidade_nfe.WidthPercent := 100.000000000000000000;
    edquantidade_nfe.DataField := 'nfe_lote.quantidade_nfe';
    edquantidade_nfe.DataSource := DataSource;
    edcodigo_interno_lote.SetParentComponent(Self);
    edcodigo_interno_lote.Name := 'edcodigo_interno_lote';
    edcodigo_interno_lote.Left := 133;
    edcodigo_interno_lote.Top := 380;
    edcodigo_interno_lote.Width := 100;
    edcodigo_interno_lote.Height := 21;
    edcodigo_interno_lote.ChildOrder := 41;
    edcodigo_interno_lote.Enabled := False;
    edcodigo_interno_lote.HeightPercent := 100.000000000000000000;
    edcodigo_interno_lote.TabOrder := 12;
    edcodigo_interno_lote.Text := 'edcodigo_interno';
    edcodigo_interno_lote.WidthPercent := 100.000000000000000000;
    edcodigo_interno_lote.DataField := 'nfe_lote.codigo_interno';
    edcodigo_interno_lote.DataSource := DataSource;
    edinclusao_lote.SetParentComponent(Self);
    edinclusao_lote.Name := 'edinclusao_lote';
    edinclusao_lote.Left := 376;
    edinclusao_lote.Top := 328;
    edinclusao_lote.Width := 100;
    edinclusao_lote.Height := 21;
    edinclusao_lote.ChildOrder := 45;
    edinclusao_lote.Enabled := False;
    edinclusao_lote.HeightPercent := 100.000000000000000000;
    edinclusao_lote.TabOrder := 14;
    edinclusao_lote.Text := 'edinclusao';
    edinclusao_lote.WidthPercent := 100.000000000000000000;
    edinclusao_lote.DataField := 'nfe_lote.inclusao';
    edinclusao_lote.DataSource := DataSource;
    edalteracao_lote.SetParentComponent(Self);
    edalteracao_lote.Name := 'edalteracao_lote';
    edalteracao_lote.Left := 376;
    edalteracao_lote.Top := 355;
    edalteracao_lote.Width := 100;
    edalteracao_lote.Height := 21;
    edalteracao_lote.ChildOrder := 47;
    edalteracao_lote.Enabled := False;
    edalteracao_lote.HeightPercent := 100.000000000000000000;
    edalteracao_lote.TabOrder := 15;
    edalteracao_lote.Text := 'edalteracao';
    edalteracao_lote.WidthPercent := 100.000000000000000000;
    edalteracao_lote.DataField := 'nfe_lote.alteracao';
    edalteracao_lote.DataSource := DataSource;
    edexclusao_lote.SetParentComponent(Self);
    edexclusao_lote.Name := 'edexclusao_lote';
    edexclusao_lote.Left := 376;
    edexclusao_lote.Top := 382;
    edexclusao_lote.Width := 100;
    edexclusao_lote.Height := 21;
    edexclusao_lote.ChildOrder := 49;
    edexclusao_lote.Enabled := False;
    edexclusao_lote.HeightPercent := 100.000000000000000000;
    edexclusao_lote.TabOrder := 16;
    edexclusao_lote.Text := 'edexclusao';
    edexclusao_lote.WidthPercent := 100.000000000000000000;
    edexclusao_lote.DataField := 'nfe_lote.exclusao';
    edexclusao_lote.DataSource := DataSource;
    cbxexcluido_lote.SetParentComponent(Self);
    cbxexcluido_lote.Name := 'cbxexcluido_lote';
    cbxexcluido_lote.Left := 377;
    cbxexcluido_lote.Top := 301;
    cbxexcluido_lote.Width := 100;
    cbxexcluido_lote.Height := 22;
    cbxexcluido_lote.Caption := 'cbxexcluido';
    cbxexcluido_lote.ChildOrder := 33;
    cbxexcluido_lote.Enabled := False;
    cbxexcluido_lote.HeightPercent := 100.000000000000000000;
    cbxexcluido_lote.WidthPercent := 100.000000000000000000;
    cbxexcluido_lote.DataField := 'nfe_lote.excluido';
    cbxexcluido_lote.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := NfeDataset;
    DataSource.Left := 216;
    DataSource.Top := 216;
    NfeDataset.SetParentComponent(Self);
    NfeDataset.Name := 'NfeDataset';
    NfeDataset.AfterApplyUpdates := NfeDatasetAfterApplyUpdates;
    NfeDataset.AfterOpen := NfeDatasetAfterOpen;
    NfeDataset.EntitySetName := 'Nfe';
    NfeDataset.Connection := DMConnection.ApiConnection;
    NfeDataset.Left := 128;
    NfeDataset.Top := 216;
    NfeDatasetid.SetParentComponent(NfeDataset);
    NfeDatasetid.Name := 'NfeDatasetid';
    NfeDatasetid.FieldName := 'id';
    NfeDatasetid.Required := True;
    NfeDatasetaliado_id.SetParentComponent(NfeDataset);
    NfeDatasetaliado_id.Name := 'NfeDatasetaliado_id';
    NfeDatasetaliado_id.FieldName := 'aliado_id';
    NfeDatasetaliado_id.Required := True;
    NfeDatasetdata_base_id.SetParentComponent(NfeDataset);
    NfeDatasetdata_base_id.Name := 'NfeDatasetdata_base_id';
    NfeDatasetdata_base_id.FieldName := 'data_base_id';
    NfeDatasetdata_base_id.Required := True;
    NfeDatasetnfe_lote_id.SetParentComponent(NfeDataset);
    NfeDatasetnfe_lote_id.Name := 'NfeDatasetnfe_lote_id';
    NfeDatasetnfe_lote_id.FieldName := 'nfe_lote_id';
    NfeDatasetnfe_es.SetParentComponent(NfeDataset);
    NfeDatasetnfe_es.Name := 'NfeDatasetnfe_es';
    NfeDatasetnfe_es.FieldName := 'nfe_es';
    SetEvent(NfeDatasetnfe_es, Self, 'OnGetText', 'NfeDatasetnfe_esGetText');
    NfeDatasetnfe_complementar.SetParentComponent(NfeDataset);
    NfeDatasetnfe_complementar.Name := 'NfeDatasetnfe_complementar';
    NfeDatasetnfe_complementar.FieldName := 'nfe_complementar';
    NfeDatasetnfe_complementar.Required := True;
    NfeDatasetchave_acesso.SetParentComponent(NfeDataset);
    NfeDatasetchave_acesso.Name := 'NfeDatasetchave_acesso';
    NfeDatasetchave_acesso.FieldName := 'chave_acesso';
    NfeDatasetchave_acesso.Size := 255;
    NfeDatasetnfe_transmissao.SetParentComponent(NfeDataset);
    NfeDatasetnfe_transmissao.Name := 'NfeDatasetnfe_transmissao';
    NfeDatasetnfe_transmissao.FieldName := 'nfe_transmissao';
    NfeDatasetnfe_transmissao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetvalor_total.SetParentComponent(NfeDataset);
    NfeDatasetvalor_total.Name := 'NfeDatasetvalor_total';
    NfeDatasetvalor_total.FieldName := 'valor_total';
    NfeDatasetvalor_total.DisplayFormat := '#,##0.00';
    NfeDatasetnfe_cancelada.SetParentComponent(NfeDataset);
    NfeDatasetnfe_cancelada.Name := 'NfeDatasetnfe_cancelada';
    NfeDatasetnfe_cancelada.FieldName := 'nfe_cancelada';
    NfeDatasetcancelamento_justificativa.SetParentComponent(NfeDataset);
    NfeDatasetcancelamento_justificativa.Name := 'NfeDatasetcancelamento_justificativa';
    NfeDatasetcancelamento_justificativa.FieldName := 'cancelamento_justificativa';
    NfeDatasetcancelamento_justificativa.Size := 255;
    NfeDatasetcancelamento_data.SetParentComponent(NfeDataset);
    NfeDatasetcancelamento_data.Name := 'NfeDatasetcancelamento_data';
    NfeDatasetcancelamento_data.FieldName := 'cancelamento_data';
    NfeDatasetcancelamento_data.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetxml_s3.SetParentComponent(NfeDataset);
    NfeDatasetxml_s3.Name := 'NfeDatasetxml_s3';
    NfeDatasetxml_s3.FieldName := 'xml_s3';
    NfeDatasetxml_s3.Size := 65536;
    NfeDatasetcodigo_interno.SetParentComponent(NfeDataset);
    NfeDatasetcodigo_interno.Name := 'NfeDatasetcodigo_interno';
    NfeDatasetcodigo_interno.FieldName := 'codigo_interno';
    NfeDatasetcodigo_interno.Required := True;
    NfeDatasetexcluido.SetParentComponent(NfeDataset);
    NfeDatasetexcluido.Name := 'NfeDatasetexcluido';
    NfeDatasetexcluido.FieldName := 'excluido';
    NfeDatasetinclusao.SetParentComponent(NfeDataset);
    NfeDatasetinclusao.Name := 'NfeDatasetinclusao';
    NfeDatasetinclusao.FieldName := 'inclusao';
    NfeDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetalteracao.SetParentComponent(NfeDataset);
    NfeDatasetalteracao.Name := 'NfeDatasetalteracao';
    NfeDatasetalteracao.FieldName := 'alteracao';
    NfeDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetexclusao.SetParentComponent(NfeDataset);
    NfeDatasetexclusao.Name := 'NfeDatasetexclusao';
    NfeDatasetexclusao.FieldName := 'exclusao';
    NfeDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetnfe_loteid.SetParentComponent(NfeDataset);
    NfeDatasetnfe_loteid.Name := 'NfeDatasetnfe_loteid';
    NfeDatasetnfe_loteid.FieldName := 'nfe_lote.id';
    NfeDatasetnfe_loteemissao.SetParentComponent(NfeDataset);
    NfeDatasetnfe_loteemissao.Name := 'NfeDatasetnfe_loteemissao';
    NfeDatasetnfe_loteemissao.FieldName := 'nfe_lote.emissao';
    NfeDatasetnfe_loteemissao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetnfe_lotecodigo.SetParentComponent(NfeDataset);
    NfeDatasetnfe_lotecodigo.Name := 'NfeDatasetnfe_lotecodigo';
    NfeDatasetnfe_lotecodigo.FieldName := 'nfe_lote.codigo';
    NfeDatasetnfe_lotequantidade_nfe.SetParentComponent(NfeDataset);
    NfeDatasetnfe_lotequantidade_nfe.Name := 'NfeDatasetnfe_lotequantidade_nfe';
    NfeDatasetnfe_lotequantidade_nfe.FieldName := 'nfe_lote.quantidade_nfe';
    NfeDatasetnfe_lotecodigo_interno.SetParentComponent(NfeDataset);
    NfeDatasetnfe_lotecodigo_interno.Name := 'NfeDatasetnfe_lotecodigo_interno';
    NfeDatasetnfe_lotecodigo_interno.FieldName := 'nfe_lote.codigo_interno';
    NfeDatasetnfe_loteexcluido.SetParentComponent(NfeDataset);
    NfeDatasetnfe_loteexcluido.Name := 'NfeDatasetnfe_loteexcluido';
    NfeDatasetnfe_loteexcluido.FieldName := 'nfe_lote.excluido';
    NfeDatasetnfe_loteinclusao.SetParentComponent(NfeDataset);
    NfeDatasetnfe_loteinclusao.Name := 'NfeDatasetnfe_loteinclusao';
    NfeDatasetnfe_loteinclusao.FieldName := 'nfe_lote.inclusao';
    NfeDatasetnfe_loteinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetnfe_lotealteracao.SetParentComponent(NfeDataset);
    NfeDatasetnfe_lotealteracao.Name := 'NfeDatasetnfe_lotealteracao';
    NfeDatasetnfe_lotealteracao.FieldName := 'nfe_lote.alteracao';
    NfeDatasetnfe_lotealteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    NfeDatasetnfe_loteexclusao.SetParentComponent(NfeDataset);
    NfeDatasetnfe_loteexclusao.Name := 'NfeDatasetnfe_loteexclusao';
    NfeDatasetnfe_loteexclusao.FieldName := 'nfe_lote.exclusao';
    NfeDatasetnfe_loteexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    XDataClientNfeGet.SetParentComponent(Self);
    XDataClientNfeGet.Name := 'XDataClientNfeGet';
    XDataClientNfeGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientNfeGet, Self, 'OnLoad', 'XDataClientNfeGetLoad');
    XDataClientNfeGet.Left := 24;
    XDataClientNfeGet.Top := 216;
  finally
    lbid.AfterLoadDFMValues;
    lbnfe_es.AfterLoadDFMValues;
    lbnfe_complementar.AfterLoadDFMValues;
    lbchave_acesso.AfterLoadDFMValues;
    lbnfe_transmissao.AfterLoadDFMValues;
    lbvalor_total.AfterLoadDFMValues;
    lbnfe_cancelada.AfterLoadDFMValues;
    lbcancelamento_justificativa.AfterLoadDFMValues;
    lbcancelamento_data.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbid_lote.AfterLoadDFMValues;
    lbemissao.AfterLoadDFMValues;
    lbcodigo.AfterLoadDFMValues;
    lbquantidade_nfe.AfterLoadDFMValues;
    lbcodigo_interno_lote.AfterLoadDFMValues;
    lbexcluido_lote.AfterLoadDFMValues;
    lbinclusao_lote.AfterLoadDFMValues;
    lbalteracao_lote.AfterLoadDFMValues;
    lbexclusao_lote.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednfe_es.AfterLoadDFMValues;
    edchave_acesso.AfterLoadDFMValues;
    ednfe_transmissao.AfterLoadDFMValues;
    edvalor_total.AfterLoadDFMValues;
    edcancelamento_justificativa.AfterLoadDFMValues;
    edcancelamento_data.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    cbxnfe_cancelada.AfterLoadDFMValues;
    cbxnfe_complementar.AfterLoadDFMValues;
    btnCopiarChaveAcesso.AfterLoadDFMValues;
    pnlDadosNfe.AfterLoadDFMValues;
    pnlDadosNfeLote.AfterLoadDFMValues;
    edid_lote.AfterLoadDFMValues;
    edemissao.AfterLoadDFMValues;
    edcodigo.AfterLoadDFMValues;
    edquantidade_nfe.AfterLoadDFMValues;
    edcodigo_interno_lote.AfterLoadDFMValues;
    edinclusao_lote.AfterLoadDFMValues;
    edalteracao_lote.AfterLoadDFMValues;
    edexclusao_lote.AfterLoadDFMValues;
    cbxexcluido_lote.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    NfeDataset.AfterLoadDFMValues;
    NfeDatasetid.AfterLoadDFMValues;
    NfeDatasetaliado_id.AfterLoadDFMValues;
    NfeDatasetdata_base_id.AfterLoadDFMValues;
    NfeDatasetnfe_lote_id.AfterLoadDFMValues;
    NfeDatasetnfe_es.AfterLoadDFMValues;
    NfeDatasetnfe_complementar.AfterLoadDFMValues;
    NfeDatasetchave_acesso.AfterLoadDFMValues;
    NfeDatasetnfe_transmissao.AfterLoadDFMValues;
    NfeDatasetvalor_total.AfterLoadDFMValues;
    NfeDatasetnfe_cancelada.AfterLoadDFMValues;
    NfeDatasetcancelamento_justificativa.AfterLoadDFMValues;
    NfeDatasetcancelamento_data.AfterLoadDFMValues;
    NfeDatasetxml_s3.AfterLoadDFMValues;
    NfeDatasetcodigo_interno.AfterLoadDFMValues;
    NfeDatasetexcluido.AfterLoadDFMValues;
    NfeDatasetinclusao.AfterLoadDFMValues;
    NfeDatasetalteracao.AfterLoadDFMValues;
    NfeDatasetexclusao.AfterLoadDFMValues;
    NfeDatasetnfe_loteid.AfterLoadDFMValues;
    NfeDatasetnfe_loteemissao.AfterLoadDFMValues;
    NfeDatasetnfe_lotecodigo.AfterLoadDFMValues;
    NfeDatasetnfe_lotequantidade_nfe.AfterLoadDFMValues;
    NfeDatasetnfe_lotecodigo_interno.AfterLoadDFMValues;
    NfeDatasetnfe_loteexcluido.AfterLoadDFMValues;
    NfeDatasetnfe_loteinclusao.AfterLoadDFMValues;
    NfeDatasetnfe_lotealteracao.AfterLoadDFMValues;
    NfeDatasetnfe_loteexclusao.AfterLoadDFMValues;
    XDataClientNfeGet.AfterLoadDFMValues;
  end;
end;

end.
